import { Container, CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { MODEL_ROUTES } from 'constants/index'
import SnackbarProvider from 'contexts/Snackbar/provider'
import { createBrowserHistory } from 'history'
import mixpanel from 'mixpanel-browser'
import { useEffect } from 'react'
import { BrowserRouter, matchPath, useLocation } from 'react-router-dom'
import { getMixpanelToken } from 'utils/token/token'
import theme from './themes/light'

import RouterContext from './contexts/Router'

import Routes from './routes'

function AppLayout() {
  const { pathname } = useLocation()
  const wideModelRoutes = [MODEL_ROUTES.MODEL_LIST, MODEL_ROUTES.SENT_MESSAGE_LIST]
  const isWideModelRoute =
    pathname.startsWith(MODEL_ROUTES.FLOWS) ||
    wideModelRoutes.some((route) => matchPath({ path: route, end: true }, pathname))

  return (
    <Container
      maxWidth={isWideModelRoute ? false : 'xl'}
      sx={
        isWideModelRoute
          ? {
              height: '100dvh',
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
            }
          : undefined
      }
    >
      <Routes />
    </Container>
  )
}

function App() {
  useEffect(() => {
    const mixpanelToken = getMixpanelToken()
    mixpanel.init(mixpanelToken, {
      debug: true,
      ignore_dnt: true,
    })
  }, [])

  const history = createBrowserHistory({ forceRefresh: true })

  return (
    <BrowserRouter>
      <SnackbarProvider>
        <RouterContext.Provider value={history}>
          <ThemeProvider theme={theme}>
            <CssBaseline enableColorScheme />
            <AppLayout />
          </ThemeProvider>
        </RouterContext.Provider>
      </SnackbarProvider>
    </BrowserRouter>
  )
}

export default App
